import React, { Component } from "react";
import { Table, Card, Row, Col, Form, Image, Button } from "react-bootstrap";
import CreditNotesView from "./CreditNotesView";
import AddCreditNotes from "./AddCreditNotes";
import ReactPaginate from "react-paginate";
import { DropdownButton, OverlayTrigger, Tooltip } from "react-bootstrap";
var dateFormat = require("dateformat");

class CreditNotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCreditNotesModal: false,
      searchcreditnotes: "",
      creditfilter: "",
      showCreditNotesAddModel: false,
      page: 0,
      perPage: 10
    };
  }
  componentDidMount() {
    this.props.fetchCreditNotes({
      page: undefined,
      search: this.state.searchcreditnotes,
      filter: this.state.creditfilter
    });
  }

  showCreditNotesDetail = item => {
    this.setState({
      showCreditNotesModal: true,
      CreditNotesToShow: item
    });
  };

  closeCreditNotesModal = () => {
    this.setState({
      showCreditNotesModal: false
    });
  };

  handleAddCreditNotes = () => {
    this.setState({
      showCreditNotesAddModel: true
    });
  };
  closeAddCreditNotesModel = () => {
    this.setState({
      showCreditNotesAddModel: false
    });
  };

  handlePageClick = e => {
    const selectedPayPage = e.selected;
    this.props.pageSelected({
      page: selectedPayPage + 1,
      search: this.state.searchcreditnotes,
      filter: this.state.creditfilter
    });
    this.setState({ page: selectedPayPage });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  creditnoteSearch = ev => {
    this.setState(
      {
        ...this.state,
        searchcreditnotes: ev.target.value,
        creditfilter: "",
        page: 0
      },
      () => {
        this.props.fetchCreditNotes({
          page: undefined,
          search: this.state.searchcreditnotes,
          filter: this.state.creditfilter
        });
      }
    );
  };

  renderTooltip = props => (
    <Tooltip id="button-tooltip" {...props}>
      View
    </Tooltip>
  );

  render() {
    // const count = this.props.CreditNotesCount;
    // console.log(this.props.CreditNotesDetails);

    const { CreditNotesDetails, CreditNotesCount } = this.props;
    const {
      showCreditNotesModal,
      showCreditNotesAddModel,
      page,
      perPage,
      searchcreditnotes,
      creditfilter
    } = this.state;
    const {
      creditnoteSearch,
      resetPage,
      handlePageClick
    } = this;

    // console.log(CreditNotesCount);
    //For Pagination
    const count = CreditNotesCount;
    let p = page + 1;
    let creditnotePageCount = Math.ceil(count / perPage);

    return (
      <div className="salesreturndiv">
        <Card>
          {/* <Card.Header className="commontableheader"> */}
          <div className="salesheader">
            <Row>
              <Col xs={12} sm={12} md={4} lg={4}>
                <div>
                  <h5 className="tablecardtitle">Credit Notes</h5>
                </div>
              </Col>
              <Col xs={12} sm={12} md={4} lg={4}>
                <div className="commonInputdiv">
                  <div className="commonInput">
                    <i className="fa fa-search fa-lg cmnSearchIcon"></i>
                    <input
                      type="text"
                      placeholder="Reference Number"
                      value={searchcreditnotes}
                      onChange={creditnoteSearch}
                    />
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={12} md={4} lg={4}>
                <div className="salescommonRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">
                    {CreditNotesCount === undefined ? (
                      0
                    ) : (
                      <span>{CreditNotesCount}</span>
                    )}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </div>
          {/* </Card.Header> */}
          <Card.Body className="tableCardBody">
            <div className="tablecommonCardBody">
              <Table hover responsive className="">
                <thead className="tablecommonCard">
                  <tr>
                    <th>#</th>
                    <th>Reference No</th>
                    <th>Return ID</th>
                    <th>Chemist Name</th>
                    <th>Organization Name</th>
                    <th>Amount </th>
                    <th>Created Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody className="tableBody">
                  {this.props.CreditNotesDetails &&
                    this.props.CreditNotesDetails.map((item, i) => (
                      <tr key={i}>
                        <th scope="row">{10 * (p - 1) + i + 1}</th>
                        <td className="cmn_Cap">
                          {" "}
                          {item !== null && item.crdtRefNo}{" "}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null &&
                            item.returnId !== null &&
                            item.returnId.orderNo}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null &&
                            item.crdtTo !== null &&
                            item.crdtTo.name}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null &&
                            item.chmstDtls !== null &&
                            item.chmstDtls.name}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.amnt?"INR "+item.amnt:null}
                        </td>

                        <td className="cmn_Cap">
                          {/* {item !== null && item.createdAt
                            ? dateFormat(item.createdAt, "dd-mmm-yyyy, h:MM TT")
                            : null} */}
                          {item !== null && item.createdAt
                            ? dateFormat(item.createdAt, "dd-mmm-yyyy")
                            : null}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              marginLeft: "15px"
                            }}
                          >
                            {/* <i
                              className="fa fa-eye fa-lg "
                              onClick={() =>
                                this.showCreditNotesDetail({ item: item })
                              }
                            ></i> */}
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={this.renderTooltip}
                            >
                              <i
                                className="fa fa-eye fa-lg "
                                onClick={() =>
                                  this.showCreditNotesDetail({ item: item })
                                }
                              ></i>
                            </OverlayTrigger>
                            <CreditNotesView
                              show={this.state.showCreditNotesModal}
                              close={this.closeCreditNotesModal}
                              CreditNotesToShow={this.state.CreditNotesToShow}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              {creditnotePageCount > 1 ? (
                <div className="paginationDiv">
                  <ReactPaginate
                    forcePage={page}
                    previousLabel={"Prev"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={creditnotePageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination flex-wrap"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                  />
                </div>
              ) : null}

              {(this.props.CreditNotesDetails === undefined ||
                (this.props.CreditNotesDetails &&
                  this.props.CreditNotesDetails.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Credit Notes Found</div>
                </div>
              )}
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default CreditNotes;
